import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LoginContainer,
  LoginForm,
  InputField,
  SubmitButton,
  Title,
  Logo,
  ErrorMessage,
} from "./LoginPage.styles";
import logo from "../../assets/logo-v2.png";
import api from "../../services/api";
import Header from "../../components/Header/Header";
import { PROJECT_NAME } from "../../constants/project";

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // 1. Login: obter token
      const params = new URLSearchParams();
      params.append("username", formData.email);
      params.append("password", formData.password);

      const loginResponse = await api.post("/auth/token", params.toString(), {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      // 2. Armazenar o token
      const token = loginResponse.data.access_token;

      localStorage.setItem("access_token", token);

      // 3. Buscar dados do usuário logado 
     const userResponse = await api.get("/users/me");
     const user = userResponse.data;

      // 4. Armazenar o usuário
      localStorage.setItem("user", JSON.stringify(user));
     

      // 5. Redirecionar para o dashboard
      navigate("/dashboard");

    } catch (error) {
      setError(error.response?.data?.detail || "Erro ao tentar fazer login");
    }
  };

  return (
    <>
      <Header /> 

      <LoginContainer>
        <LoginForm onSubmit={handleSubmit}>
          <Logo src={logo} alt="Brasão do Estado de Minas Gerais" />
          <Title>{PROJECT_NAME}</Title>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <InputField
            type="email"
            name="email"
            placeholder="Digite seu e-mail"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <InputField
            type="password"
            name="password"
            placeholder="Digite sua senha"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <SubmitButton type="submit">Entrar</SubmitButton>
        </LoginForm>
      </LoginContainer>
    </>
  );
};

export default LoginPage;
